import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Table, Button} from "reactstrap";
import {GetFormValue3Tiers, SyncDelete} from 'datasync-core'
import {useSelector, useDispatch } from 'react-redux';
import {deleteHiring, revertStatusHirings} from "../../redux/hiringSlice";
import {openModalHiring} from "../../redux/modalSlice";
import {openModalStat, openModal} from "../../redux/modalSlice";
import {globals} from "../Globals/Globals"
import HiringCard from "../Hiring/HiringCard";

const HiringsRawTableDataSync = (props) =>{
    const {deleteHiring_result} = useSelector((state) => state.hirings)
    const dispatch = useDispatch();

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (deleteHiring_result.status == "deleted"){
            try{
                dispatch(openModal({title:"Hiring supprimé"}));
            }
            finally{
                dispatch(revertStatusHirings())
            }
        }

        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [dispatch, deleteHiring_result]);

     /**
     * 
     * @param {*} this 
     * @param {*} handleManager 
     * @param {*} userItem 
     * @param {*} data_guid 
     */
    const handleManager = async (p_s_item_key, p_callback_handler) => {
        try {
            if (globals.parameters.debugging) console.log("handleManager::p_s_item_key =>", p_s_item_key)
                p_callback_handler(props.hiring_list.find((item) => item.data_guid == p_s_item_key))
        } catch (error) {
            alert(`handleManager for ${p_callback_handler} raise error ${error.message}`)
        }
    }
    

    const tableRendering = () => {
        let table_body = null;

        if (!((props.hiring_list != null) && (props.hiring_list.length > 0))){
            table_body = <tr><td colSpan="4">Aucune offre d'emploi disponible</td></tr>;
        }
        else{
            table_body = props.hiring_list.map((hiringItem,i)=>{
                return  <tr key={hiringItem.data_guid} className="thumbnail">
                            <td id="table-item-container">
                                <div id="table-item">
                                    <HiringCard
                                        key={hiringItem.data_guid}
                                        title={hiringItem.data_blob.data_tier.hiring_title}
                                        salaryRange={hiringItem.data_blob.data_tier.hiring_salary}
                                        location={hiringItem.data_blob.data_tier.hiring_location}
                                        contractType={hiringItem.data_blob.data_tier.hiring_contract}
                                        hiringType={hiringItem.data_blob.data_tier.hiring_type}
                                    />
                                </div>
                                <div id="table-commands">
                                    {!props.read_only &&
                                        <div className="cmd_btn_delete">
                                            <Button onClick={()=>{handleManager(hiringItem.data_guid, (hiringObject)=>{
                                                dispatch(openModal(
                                                                    {title:`Supprimer l'hiring ${hiringObject.data_blob.data_tier.hiring_title} ?`,
                                                                        okCallBack:(DialogObject)=>{dispatch(deleteHiring(hiringObject))}})) })}}
                                            style={{cursor:"pointer"}}>Effacer</Button>
                                        </div>}
                                    
                                    {!props.read_only &&
                                        <div className="cmd_btn_update">
                                            <Button onClick={()=>{handleManager(hiringItem.data_guid, (hiringObject)=>{dispatch(openModalHiring({hiring_data_guid:hiringObject, read_only:false}))})}} 
                                            style={{cursor:"pointer"}}>Modifier</Button>
                                        </div>}
                                </div>
                            </td>
                        </tr>});
                }

        return(
            <Table striped responsive={true}>
               <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    return (
        <>
            {tableRendering()}
        </>);
}

HiringsRawTableDataSync.propTypes = { 
    table: PropTypes.bool,
};

HiringsRawTableDataSync.defaultProps = {
    table:true,
};



export default HiringsRawTableDataSync;
